import React from 'react'
import ReactGA from 'react-ga'
import Clipboard from 'clipboard'

import GameLink from './GameLink'

class GameLinkContainer extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      buttonText: 'Copy'
    }
  }
  componentDidMount() {
    this.clipboard = new Clipboard('#copy-link-button')
    this.clipboard.on('success', e => {
      ReactGA.event({
        category: 'Game',
        action: 'Clicked "copy invite link" button',
      })
      this.setState({
        buttonText: 'Copied!',
      })
    })
  }

  componentWillUnmount() {
    this.clipboard.destroy()
  }

  render() {
    return <GameLink
      link={window.location.host+'/game/'+this.props.game.id}
      buttonText={this.state.buttonText}
      />
  }

}

export default GameLinkContainer



// WEBPACK FOOTER //
// ./src/views/game/components/GameLinkContainer.jsx